/**
 * Selector hooks for Zustand store
 * Optimized for efficient component re-renders
 */

import { useGameStore } from '../stores/gameStore';

/**
 * Core player state selectors
 */
export const usePlayerState = () =>
  useGameStore((state) => state.playerState);

export const useCurrency = () =>
  useGameStore((state) => state.playerState.currency);

export const useInventory = () =>
  useGameStore((state) => state.playerState.inventory);

export const useEquippedGear = () =>
  useGameStore((state) => state.playerState.equippedGear);

export const useOwnedEquipment = () =>
  useGameStore((state) => state.playerState.ownedEquipment);

export const useCurrentZone = () =>
  useGameStore((state) => state.playerState.currentZone);

export const useStats = () =>
  useGameStore((state) => state.playerState.stats);

export const useSettings = () =>
  useGameStore((state) => state.playerState.settings);

/**
 * Derived/computed selectors
 */
export const usePlayerStats = () =>
  useGameStore((state) => state.playerStats);

export const useFishingState = () =>
  useGameStore((state) => state.fishingState);

export const useCurrentTab = () =>
  useGameStore((state) => state.currentTab);

/**
 * Inventory-specific selectors
 */
export const useInventoryCount = () =>
  useGameStore((state) => state.playerState.inventory.currentCount);

export const useInventoryCapacity = () =>
  useGameStore((state) => state.playerState.inventory.capacity);

export const useIsInventoryFull = () =>
  useGameStore(
    (state) =>
      state.playerState.inventory.currentCount >=
      state.playerState.inventory.capacity
  );

export const useInventorySpace = () =>
  useGameStore(
    (state) =>
      state.playerState.inventory.capacity -
      state.playerState.inventory.currentCount
  );

/**
 * Equipment-specific selectors
 */
export const useHasEquipment = (equipmentId: string) =>
  useGameStore((state) => equipmentId in state.playerState.ownedEquipment);

export const useIsEquipped = (equipmentId: string) =>
  useGameStore((state) =>
    Object.values(state.playerState.equippedGear).includes(equipmentId)
  );

/**
 * Quest panel selectors
 */
export const useActiveQuests = () =>
  useGameStore((state) => state.playerState.quests.activeQuests);

export const usePendingQuestOffer = () =>
  useGameStore((state) => state.pendingQuestOffer);

export const useNewlyUnlockedQuests = () =>
  useGameStore((state) => state.newlyUnlockedQuests);

